import { apiClient } from "@/App";
import { toast } from "sonner";
import { logger } from "@/lib/logger";

const urlB64ToUint8Array = (b64) => {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
};

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    return reg;
  } catch (e) {
    console.error("SW register failed", e);
    return null;
  }
}

export async function subscribePush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    toast.error("Browser tidak mendukung Web Push");
    return { ok: false, reason: "unsupported" };
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    return { ok: false, reason: "permission" };
  }
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    try {
      const { data } = await apiClient.get("/push/vapid-public-key");
      const key = urlB64ToUint8Array(data.public_key);
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: key,
      });
    } catch (e) {
      console.error("subscribe failed", e);
      toast.error("Gagal subscribe push");
      return { ok: false, reason: "subscribe-failed" };
    }
  }
  try {
    await apiClient.post("/push/subscribe", { subscription: sub.toJSON() });
  } catch (e) {
    console.error("push/subscribe backend failed", e);
    return { ok: false, reason: "backend" };
  }
  return { ok: true, subscription: sub };
}

export async function unsubscribePush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try {
      await apiClient.post("/push/unsubscribe", { subscription: sub.toJSON() });
    } catch (err) {
      logger.debug("push/unsubscribe backend failed", err);
    }
    await sub.unsubscribe();
  }
}

export async function sendTestPush() {
  try {
    const { data } = await apiClient.post("/push/test");
    toast.success(`Notifikasi uji dikirim ke ${data.sent} klien`);
  } catch (err) {
    console.error("test push failed", err);
    toast.error("Gagal mengirim notifikasi uji");
  }
}
